interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | "...")[] = [];
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const btnBase =
    "min-w-10 h-10 px-3 flex items-center justify-center rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer";

  return (
    <nav className="flex items-center justify-center gap-2 mt-12" aria-label="分页">
      <button
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className={`${btnBase} border border-background-300 text-foreground-600 hover:border-secondary-400 hover:text-secondary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {pages.map((p, idx) =>
        p === "..." ? (
          <span key={`dot-${idx}`} className="px-2 text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={`${btnBase} ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-600 hover:border-secondary-400 hover:text-secondary-700"
            }`}
          >
            {p}
          </button>
        ),
      )}
      <button
        onClick={() => onChange(current + 1)}
        disabled={current === total}
        className={`${btnBase} border border-background-300 text-foreground-600 hover:border-secondary-400 hover:text-secondary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}